import { Grid2 as Grid } from "@mui/material";

import { Form } from "@shared/components";
import { CredentialSchemaField } from "@modules/erpIntegrations/types";

interface CredentialFieldsProps {
  schema: CredentialSchemaField[];
  namePrefix?: string;
}

export function CredentialFields({
  schema,
  namePrefix = "credentials",
}: CredentialFieldsProps) {
  return (
    <Grid container spacing={2}>
      {schema.map((field) => {
        const name = `${namePrefix}.${field.key}`;
        const label = field.label || field.key;
        const type = field.type || "text";

        if (type === "boolean") {
          return (
            <Grid key={field.key} size={{ xs: 12 }}>
              <Form.Switch name={name} label={label} />
            </Grid>
          );
        }

        if (type === "textarea") {
          return (
            <Grid key={field.key} size={{ xs: 12 }}>
              <Form.Input
                name={name}
                label={label}
                multiline
                minRows={3}
                required={field.required}
              />
            </Grid>
          );
        }

        return (
          <Grid key={field.key} size={{ xs: 12 }}>
            <Form.Input
              name={name}
              label={label}
              type={
                type === "password"
                  ? "password"
                  : type === "url"
                    ? "url"
                    : type === "number"
                      ? "number"
                      : "text"
              }
              required={field.required}
            />
          </Grid>
        );
      })}
    </Grid>
  );
}
